<p-colorPicker [(ngModel)]="color"></p-colorPicker>
